import OLWebGLVectorLayer from 'ol/layer/WebGLVector.js'
import OLWebGLVectorLayerRenderer from 'ol/renderer/webgl/VectorLayer.js';
import WebGLRenderTarget from 'ol/webgl/RenderTarget.js';
import OLVectorStyleRenderer from 'ol/render/webgl/VectorStyleRenderer.js';
import {
	BooleanType,
	computeGeometryType,
	newParsingContext,
} from 'ol/expr/expression.js';
import {
	newEvaluationContext,
} from 'ol/expr/cpu.js';
import {
	buildExpression,
} from '../expr/cpu.js';


class VectorStyleRenderer extends OLVectorStyleRenderer {
	_variables = {};

	constructor(styleOrShaders, variables, helper, enableHitDetection, filter) {

		// let asShaders = styleOrShaders;
		// const isShaders = 'builder' in styleOrShaders;
		// if (!isShaders) {
		// 	const asRule = styleOrShaders;
		// 	const parseResult = parseLiteralStyle(
		// 		asRule.style,
		// 		variables,
		// 		asRule.filter,
		// 	);
		// 	asShaders = {
		// 		builder: parseResult.builder,
		// 		attributes: parseResult.attributes,
		// 		uniforms: parseResult.uniforms,
		// 	};
		// }

		super(styleOrShaders, variables, helper, enableHitDetection, filter);

		this._variables = variables ?? {};

		if (filter) {
			this.featureFilter_ = this.computeFeatureFilter(filter);
		}
	}

	computeFeatureFilter(filter) {
		const parsingContext = newParsingContext();
		let compiled;
		try {
			compiled = buildExpression(filter, BooleanType, parsingContext);
		} catch(error) {
			console.error(error)
			// filter expression failed to compile for CPU: ignore it
			return null;
		}

		// do not apply the filter if it depends on map state (e.g. zoom level) or any variable
		if (parsingContext.mapState || parsingContext.variables.size > 0) {
			return null;
		}

		const evalContext = newEvaluationContext();
		Object.keys(this._variables ?? {}).forEach(name => {
			evalContext.variables[name] = this._variables[name];
		})
		return (feature) => {
			evalContext.properties = feature.getPropertiesInternal();
			if (parsingContext.featureId) {
				const id = feature.getId();
				if (id !== undefined) {
					evalContext.featureId = id;
				} else {
					evalContext.featureId = null;
				}
			}
			evalContext.geometryType = computeGeometryType(feature.getGeometry());
			return /** @type {boolean} */ (compiled(evalContext));
		};
	}
};

class WebGLVectorLayerRenderer extends OLWebGLVectorLayerRenderer {
	constructor(layer, options) {
		super(layer, options);
	}

	/**
	 * @override
	 */
	reset(options) {
		this.applyOptions_(options);
		if (this.helper) {
			this.createRenderers_();
		}
		super.reset(options);
	}

	/**
	 * @override
	 */
	afterHelperCreated() {
		if (this.styleRenderers_.length) {
			// To reuse buffers
			this.styleRenderers_.forEach((renderer, i) =>
				renderer.setHelper(this.helper, this.buffers_[i]),
			);
		} else {
			this.createRenderers_();
		}

		if (this.hitDetectionEnabled_) {
			this.hitRenderTarget_ = new WebGLRenderTarget(this.helper);
		}
	}

	/**
	 * @private
	 */
	createRenderers_() {
		this.buffers_ = [];
		this.styleRenderers_ = this.styles_.map(
			(style) =>
			new VectorStyleRenderer(
				style,
				this.styleVariables_,
				this.helper,
				this.hitDetectionEnabled_,
				'filter' in style ? style.filter : null,
			),
		);
	}
};


////////////////////
////////////////////
////////////////////
class WebGLVectorLayer extends OLWebGLVectorLayer {
	constructor(options) {
		super(options);
	}

	createRenderer() {
		return new WebGLVectorLayerRenderer(this, {
			style: this.style_,
			variables: this.styleVariables_,
			disableHitDetection: this.hitDetectionDisabled_,
		});
	}
};

export default WebGLVectorLayer;